import { useSelector } from 'react-redux';

import type { RootState } from '@app-types/index';

import { INBOX_ENABLED } from '../featureFlags';

/** Org types with an inbox. S2 is all-to-all: brands and creator orgs both
 *  message (and get messaged by) other orgs. */
const INBOX_ORG_TYPES = new Set(['brand', 'creator']);

/** True when the selected org has an inbox. Kept out of the module index so
 *  the sidebar/drawer don't pull the lazy page. */
export const useInboxAvailable = (): boolean => {
  const orgType = useSelector((s: RootState) => s?.SelectedOrganization?.type);
  return INBOX_ENABLED && !!orgType && INBOX_ORG_TYPES.has(orgType);
};

export default useInboxAvailable;
